const pricing = [
  {
    id: 1,
    title: 'Personal',
    price: 50,
    unit: 'per month',
    features: [
      'Bottled water size',
      'Delivery fee',
      'Water cooler',
      'Water filtration',
      'Bottle refill',
    ],
  },
  {
    id: 2,
    title: 'Residential',
    price: 100,
    unit: 'per month',
    features: [
      'Bottled water size',
      'Delivery fee',
      'Water cooler',
      'Water filtration',
      'Bottle refill',
    ],
  },
  {
    id: 3,
    title: 'Commercial',
    price: 200,
    unit: 'per month',
    features: [
      'Bottled water size',
      'Delivery fee',
      'Water cooler',
      'Water filtration',
      'Bottle refill',
    ],
  },
];

export default pricing;